import './PlanPreviewModal.css';

export default function PlanPreviewModal({ plan, onClose }) {
  if (!plan) return null;

  const hasPdf = plan.pdfUrl && plan.pdfUrl !== '#';

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal modal-large">
        <header>
          <div>
            <h3>Visualisation — {plan.title}</h3>
            <p className="muted">Cours: {plan.course}</p>
          </div>
          <button onClick={onClose} type="button" aria-label="Fermer">
            ✕
          </button>
        </header>

        <div className="modal-body">
          {hasPdf ? (
            <iframe
              title={`Plan ${plan.title}`}
              src={plan.pdfUrl}
              className="pdf-frame"
            />
          ) : (
            <p className="muted">Aucun fichier PDF disponible.</p>
          )}
        </div>
      </div>
    </div>
  );
}
